import { useNavigate } from 'react-router-dom'
import { Lock, Home, LogIn } from 'lucide-react'

export function Unauthorized() {
  const navigate = useNavigate()

  return (
    <div className='min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4'>
      <div className='max-w-md w-full'>
        <div className='bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-8'>
          {/* Lock Icon */}
          <div className='mx-auto w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mb-6'>
            <Lock className='w-8 h-8 text-gray-400 dark:text-gray-500' />
          </div>

          {/* Text Content */}
          <div className='text-center'>
            <h1 className='text-2xl font-semibold text-gray-900 dark:text-white mb-2'>
              Access Restricted
            </h1>
            <p className='text-gray-600 dark:text-gray-400 mb-8'>
              You need to sign in to access this page
            </p>

            {/* Action Buttons */}
            <div className='space-y-3'>
              <button
                onClick={() => navigate('/')}
                className='w-full flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 font-medium rounded-md transition-colors duration-200'
              >
                <Home className='w-4 h-4' />
                Go Home
              </button>
            </div>

            <p className='mt-8 text-sm text-gray-500 dark:text-gray-400'>
              Need help? Contact your administrator
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
